import { render, staticRenderFns } from "./HeadTitle.vue?vue&type=template&id=4d16e70e&scoped=true&"
import script from "./HeadTitle.vue?vue&type=script&lang=js&"
export * from "./HeadTitle.vue?vue&type=script&lang=js&"
import style0 from "./HeadTitle.vue?vue&type=style&index=0&id=4d16e70e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d16e70e",
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QIcon});
